<template>
    <v-card
       hover
       v-on="on"
       class="ma-2 elevation-3"
       :class="{
            '': !abastecido,
            opaco: abastecido,
        }"
    >
        <v-card-title v-if="titulo" class="justify-center">
            <h3>{{ titulo }}</h3>
        </v-card-title>
        <v-divider v-if="titulo"></v-divider>
        <v-card-text>
            <v-layout justify-space-around wrap>
                <v-flex
                    xs2
                    style="
                        align-items: center;
                        justify-content: center;
                        display: flex;
                    "
                >
                    <slot name="icone"></slot>
                </v-flex>
                <v-flex xs7>
                    <slot name="principal"></slot>
                </v-flex>
                <v-flex xs3>
                    <slot name="dados_usuario"></slot>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-footer class="justify-center mt-1" v-if="footer" :color="cor">
            <slot name="footer"></slot>
        </v-footer>
    </v-card>
</template>

<script>
export default {
  props: ['titulo', 'footer', 'on', 'cor', 'abastecido']
}
</script>

<style>

</style>
